/**
 * Positive, inclusive, and kid-friendly adjectives for guest names.
 */
const adjectives = [
  "Friendly",
  "Kind",
  "Helpful",
  "Joyful",
  "Brave",
  "Calm",
  "Patient",
  "Gentle",
  "Wise",
  "Cheerful",
  "Creative",
  "Curious",
  "Honest",
  "Loyal",
  "Polite",
  "Radiant",
  "Steady",
  "Bright",
  "Caring",
  "Empathetic",
  "Sunny",
  "Happy",
  "Polite",
  "Nimble",
  "Strong",
  "Smart",
  "Quick",
  "Playful",
  "Awesome",
  "Super",
];

/**
 * Positive, inclusive, and kid-friendly nouns for guest names.
 */
const nouns = [
  "Friend",
  "Buddy",
  "Helper",
  "Ally",
  "Guide",
  "Partner",
  "Star",
  "Spark",
  "Heart",
  "Smile",
  "Wave",
  "Cloud",
  "Sun",
  "Bloom",
  "Seed",
  "Root",
  "Bridge",
  "Path",
  "Robot",
  "Pilot",
  "Captain",
  "Explorer",
  "Dreamer",
  "Maker",
  "Learner",
  "Hero",
  "Legend",
  "Pioneer",
];

/**
 * Generates a brand-aligned, positive, kid-friendly, and inclusive guest name.
 * Format: Guest[Adjective][Noun]
 * @returns {string} The generated guest name.
 */
export const generateGuestName = (): string => {
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  const randomNumber = Math.floor(100 + Math.random() * 900);
  return `Guest${adjective}${noun}${randomNumber}`;
};
